import React, { Component } from 'react'
import SectionTitleOne from '../SectionTitleOne'
import Slider from 'react-slick'

const youtubeVideos = [
    'BNHvUnu7UwI',
    'RwhryOXi_V0',
    'MK1VX6Ei7Qg',
    'VDkdb8tnyHY',
    '5Nze_sBEby8',
    'pyebeKQePJw',
    'D4zaYVYir5E',
    '_mpyYfAwRvc',
    '9JX8E9bp8tY',
    '4KQaCuWGn1w',
    'kC0JGXLgXi4',
];

const WhitePrevArrow = ({ onClick }) => (
    <button className="news-arrow news-prev" onClick={onClick} style={{ color: '#fff' }}>←</button>
);

const WhiteNextArrow = ({ onClick }) => (
    <button className="news-arrow news-next" onClick={onClick} style={{ color: '#fff' }}>→</button>
);

const VideoEmbed = ({ id }) => (
    <div style={{ position: 'relative', paddingBottom: '75%', height: 0, overflow: 'hidden', borderRadius: '8px' }}>
        <iframe
            src={`https://www.youtube.com/embed/${id}`}
            title={`Video ${id}`}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
        />
    </div>
);

function chunkArray(arr, size) {
    const result = [];
    for (let i = 0; i < arr.length; i += size) {
        result.push(arr.slice(i, i + size));
    }
    return result;
}

class GalleryOne extends Component {
    render() {
        const images = [
            require('../../assets/img/whatsinaname/gallery/Image01.png'),
            require('../../assets/img/whatsinaname/gallery/Image02.png'),
            require('../../assets/img/whatsinaname/gallery/Image03.png'),
            require('../../assets/img/whatsinaname/gallery/Image04.png'),
            require('../../assets/img/whatsinaname/gallery/Image05.png'),
        ];

        const videoItems = youtubeVideos.map(id => ({ type: 'video', id }));
        const imageItems = images.map((src, i) => ({ type: 'image', src, i }));
        const allItems = [...videoItems, ...imageItems];

        // Chunk videos and images separately so they never mix in a slide
        const desktopSlides = [
            ...chunkArray(videoItems, 6),
            ...chunkArray(imageItems, 6),
        ];
        const tabletSlides = [
            ...chunkArray(videoItems, 4),
            ...chunkArray(imageItems, 4),
        ];

        const desktopSettings = {
            dots: true,
            infinite: true,
            autoplay: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: <WhitePrevArrow />,
            nextArrow: <WhiteNextArrow />,
        };

        const mobileSettings = {
            dots: false,
            infinite: true,
            autoplay: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: <WhitePrevArrow />,
            nextArrow: <WhiteNextArrow />,
        };

        const renderItem = (item, key) => {
            if (item.type === 'video') {
                return <VideoEmbed key={key} id={item.id} />;
            }
            return <img key={key} src={item.src} alt={`gallery-${item.i + 1}`} style={{ width: '100%', borderRadius: '8px', display: 'block', aspectRatio: '16/9', objectFit: 'cover' }} />;
        };

        return (
            <section className="gallery-one-wrapper section-bg text-white section-padding vSleepDisorderBlock">
                <div className="hero-shape service-shape">
                    <img src={require("../../assets/img/shape/rmc.png")} alt="donto" className="shape shape2" />
                    <img src={require("../../assets/img/shape/plusgs.png")} alt="donto" className="shape shape4" />
                    <img src={require("../../assets/img/shape/plusg.png")} alt="donto" className="shape shape6" />
                    <img src={require("../../assets/img/shape/plusr.png")} alt="donto" className="shape shape8" />
                    <img src={require("../../assets/img/shape/sgdot.png")} alt="donto" className="shape shape9" />
                    <img src={require("../../assets/img/shape/xsrdot.png")} alt="donto" className="shape shape10" />
                    <img src={require("../../assets/img/shape/rmc.png")} alt="donto" className="shape s1" />
                    <img src={require("../../assets/img/shape/plusgs.png")} alt="donto" className="shape s2" />
                    <img src={require("../../assets/img/shape/sgdot.png")} alt="donto" className="shape s3" />
                </div>
                <div className="container">
                    <SectionTitleOne BigTitle="A Look at Our World" />

                    {/* Desktop: 2×3 grid per slide */}
                    <div className="d-none d-lg-block" style={{ padding: '0 24px' }}>
                        <Slider {...desktopSettings}>
                            {desktopSlides.map((slide, si) => (
                                <div key={si}>
                                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px' }}>
                                        {slide.map((item, ii) => renderItem(item, ii))}
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>

                    {/* Tablet: 2×2 grid per slide */}
                    <div className="d-none d-md-block d-lg-none" style={{ padding: '0 24px' }}>
                        <Slider {...desktopSettings}>
                            {tabletSlides.map((slide, si) => (
                                <div key={si}>
                                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px' }}>
                                        {slide.map((item, ii) => renderItem(item, ii))}
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>

                    {/* Mobile: 1 per slide */}
                    <div className="d-md-none" style={{ padding: '0 24px' }}>
                        <Slider {...mobileSettings}>
                            {allItems.map((item, i) => (
                                <div key={i}>
                                    {renderItem(item, i)}
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </section>
        );
    }
}

export default GalleryOne
